import React from 'react';
import { costRows } from '../data/content';
export function CostSection() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-29" data-mp="9c6jrf0j6pu2">
      <div className="mx-auto max-w-3xl" data-id="element-30" data-mp="9eaizjnhj0o0">
        <h2 className="text-center text-lg font-extrabold uppercase text-white sm:text-2xl" data-id="element-31" data-mp="4kg1mmvcqxs3">
          ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mt-6 overflow-hidden rounded-xl border border-white/10" data-id="element-32" data-mp="3vpesf6ci2n6s">
          <div className="grid grid-cols-2 bg-ink-700" data-id="element-33" data-mp="3qtzham5vn5e2">
            <p className="px-4 py-3 text-[11px] font-extrabold uppercase tracking-wide text-neutral-300 sm:text-xs" data-id="element-34" data-mp="3mqb8y19f85rr">
              Sin Sistema
            </p>
            <p className="px-4 py-3 text-[11px] font-extrabold uppercase tracking-wide text-gold-500 sm:text-xs" data-id="element-35" data-mp="3htu8c7l1byxs">
              Costo real
            </p>
          </div>
          <ul data-id="element-36" data-mp="1fz217gahschq">
            {costRows.map(row => <li key={row.without} className="grid grid-cols-2 border-t border-white/10 bg-ink-800" data-id="element-37" data-mp="1b1a6keigqc9u">
                <span className="px-4 py-3 text-[13px] text-neutral-400" data-id="element-38" data-mp="p6s2dl6jyy0g">
                  {row.without}
                </span>
                <span className="px-4 py-3 text-[13px] font-semibold text-neutral-200" data-id="element-39" data-mp="t72dfc97cem6">
                  {row.cost}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="mt-6 text-center text-base font-extrabold text-gold-400 sm:text-lg" data-id="element-40" data-mp="kabij36dz5t6">
          El próximo clavo que saques puede pagar este sistema entero.
        </p>
      </div>
    </section>;
}